// extracted by mini-css-extract-plugin
module.exports = {"edit-info-form":"Password_edit-info-form__jChNB","edit-info-form__mobile":"Password_edit-info-form__mobile__3TmOA"};